import type { ProjectDoc, WorldDoc } from '@mod/core/model'

/** A local read projection. Never write this combined view back to the log. */
export function withPrivateSessions(
  project: ProjectDoc,
  projectId: string,
  entries: WorldDoc['privateSessions'],
  shared?: WorldDoc['sharedWithMe'],
): ProjectDoc {
  const sessionMeta: NonNullable<ProjectDoc['sessionMeta']> =
    Object.fromEntries(
      Object.entries(entries ?? {}).filter(
        ([, entry]) => String(entry.projectId) === projectId,
      ),
    )
  // The guest opens a shared session beside their own project. This local
  // catalog provides a pane location, not membership in either project.
  for (const [id, entry] of Object.entries(shared ?? {})) {
    if (String(entry.kind) !== 'session' || sessionMeta[id]) continue
    sessionMeta[id] = {
      title: String(entry.title),
      titleSetBy: 'you',
      updatedAt: entry.joinedAt,
    }
  }
  return { ...project, sessionIds: Object.keys(sessionMeta), sessionMeta }
}
